'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ChartPriceRecommendationServices = function ChartPriceRecommendationServices(AbstractChart, chartGroups, chartSimpleBars, chartElementsSimpleBarsOverlays, chartXAxis, chartYAxisLines, chartConstants, chartCircles) {
  var chartParams = require('./Params');
  function getClosedClassesYAxisMax(data) {
    var dataWithoutGaps = _.filter(data, ['isGap', false]);
    return d3.max(dataWithoutGaps, function (d) {
      return Math.max(d.closedClasses, 0);
    });
  }
  function getEffectiveFareChangeYAxisMax(data) {
    var dataWithoutGaps = _.filter(data, ['isGap', false]);
    return d3.max(dataWithoutGaps, function (d) {
      return Math.max(d.effectiveFareChange, 0);
    });
  }
  var Chart = function Chart(container, formatters, chartScales, yAxisLeft, yAxisRight) {
    var dispatch = d3.dispatch('selectedService');
    d3.rebind(this, dispatch, 'on');
    AbstractChart.call(this, container);
    var groups = chartGroups('displayServiceIdKey', formatters.tooltipFormatter, true);
    var bars = chartSimpleBars('effectiveFareChange');
    var simpleBarsOverlays = chartElementsSimpleBarsOverlays('effectiveFareChange');
    var lines = chartYAxisLines();
    var circles = chartCircles('circles');
    var xAxisTickValuesHandler = function xAxisTickValuesHandler(data) {
      return _.map(data, 'displayServiceIdKey');
    };
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, xAxisTickValuesHandler).withTextRotation(chartConstants.AXIS.SKEW.DEG_30_A).withoutLine().invertAxisLine(false);
    this.render = function (data) {
      this.initChart(data, [0, data.length], chartParams);
      this.scales = chartScales(this.params, this.data, 60, 'effectiveFareChange');
      this.scalesClosedClasses = chartScales(this.params, this.data, 60, 'closedClasses', this.scales);
      this.callForDataGroup([lines, groups, bars, simpleBarsOverlays, xAxis], this.scales);
      this.callForDataGroup([circles], this.scalesClosedClasses);
      var yMax = getClosedClassesYAxisMax(data);
      if (yMax <= 5 && yMax !== 0) {
        yAxisLeft.withTickValues(_.range(yMax + 1));
      } else {
        yAxisLeft.withTickValues(null);
      }
      var yRightAxisMax = getEffectiveFareChangeYAxisMax(data);
      if (yRightAxisMax <= 5 && yRightAxisMax !== 0) {
        yAxisRight.withTickValues(_.range(yRightAxisMax + 1));
      } else {
        yAxisRight.withTickValues(null);
      }
      this.callForYAxis(yAxisLeft, this.scalesClosedClasses);
      this.callForYAxis(yAxisRight, this.scales, '.chart-y-axis.right');
    };
    groups.on('groupclick', function (d, i) {
      dispatch.selectedService(d, i);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartPriceRecommendationServices.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsSimpleBarsOverlays', 'ChartElementsXAxis', 'ChartElementsYAxisLines', 'ChartElementsConstants', 'ChartElementsCircles'];
module.exports = ChartPriceRecommendationServices;